import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent, setUserProperties } from 'firebase/analytics';

// Your web app's Firebase configuration
// Replace these values with your Firebase project configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Logging utility functions
export const logPageView = (pageName: string) => {
  logEvent(analytics, 'page_view', {
    page_name: pageName,
    page_location: window.location.href
  });
};

export const logUserAction = (actionName: string, additionalParams?: Record<string, any>) => {
  logEvent(analytics, actionName, additionalParams);
};

export const logError = (error: Error, context?: string) => {
  logEvent(analytics, 'error', {
    error_message: error.message,
    error_stack: error.stack,
    context: context
  });
};

export const setAnalyticsUserProperties = (properties: Record<string, string>) => {
  setUserProperties(analytics, properties);
};

export default analytics; 